const EmptyResults = () => {
  return (
    <div className="empty-results">
      <div className="empty-results__text">
        <h2 className="h3">No matching results</h2>
        <p>
          Try another key word, or use the filter options to find results by
          problem, product, and date range
        </p>
      </div>
      <div className="empty-results__icon">
        <img
          src="/_resources/themes/bos/images/no-ill.png"
          width={247}
          height={208}
          alt="No matching case notes"
        />
      </div>
    </div>
  );
};

export default EmptyResults;
